import {
    SET_LOCAL_PRODUCTS,
    SET_LOCAL_SUBSTANCES,
    SET_PRODUCT_DOWNLOAD_IDS,
    SET_SUBSTANCE_DOWNLOAD_IDS,
    SET_PROFILE_DOWNLOAD_IDS,
    SET_OFFLINE_MODE
} from '../actions/local';

const initialState = {
    products: [],
    substances:[],
    profiles: [],
    productDownloadIDs: [],
    substanceDownloadIDs: [],
    profileDownloadIDs: [],
    isOffline: false
};

export default (state=initialState, action) => {
    switch(action.type) {
        case SET_LOCAL_PRODUCTS:
            return Object.assign({}, state, {
                products: action.payload
            });
        case SET_LOCAL_SUBSTANCES:
            return Object.assign({}, state, {
                substances: action.payload
            });
        case SET_PRODUCT_DOWNLOAD_IDS:
            return Object.assign({}, state, {
                productDownloadIDs: action.payload
            });
        case SET_SUBSTANCE_DOWNLOAD_IDS:
            return Object.assign({}, state, {
                substanceDownloadIDs: action.payload
            });
        case SET_PROFILE_DOWNLOAD_IDS:
            return Object.assign({}, state, {
                profileDownloadIDs: action.payload
            });
        case SET_OFFLINE_MODE:
            return Object.assign({}, state, {
                isOffline: action.payload
            });
        default:
            return state;
    }
}